import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-provider-apply',
    templateUrl: './provider-apply.component.html',
    styleUrls: ['./provider-apply.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProviderApplyComponent {

}
